import Regex from '../Regex'

export default class Alpha extends Regex {
  get ruleName () {
    return 'alpha'
  }

  passes () {
    return super.passes(/^[A-Za-zÀ-ÿ]+$/)
  }
}
